import React, { useEffect, useState, FC } from "react";
import { Button, Form, message, Modal, Tag, Tooltip, Upload } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { DetailType } from "@/types/ScmEnums";
import { usePurchaseEnquiryModel } from "../../purchaseEnquiryModel";
import { debounce } from "lodash";
import FontIcon from "@/components/YhIcon";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { BankOutlined, UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import moment, { Moment } from "moment"
import { YhBox } from "@/components/YhBox";
import { momentFormat } from "@/utils/utils";
import { supplierMapModel } from "@/utils/supplierMap";

const returnList: any = {
    //配件厂家
    'approval-type.001': 'supplier-type.material',
    //辅油厂家
    'approval-type.002': 'supplier-type.002',
    //轮胎厂家
    'approval-type.003': 'supplier-type.001',
}
export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setSupplierHistoryModel,
        setSupplierHistoryVisible,
        saveLoading, setSaveLoading,
        Submit, verifyGoods,
        Transfer, topButsControl, setSupplier,
        // supplierList, setSupplierList,
        addSupplierVisible, setAddSupplierVisible, setDetailDataSource
    } = usePurchaseEnquiryDetailsModel();
    const {
        setSelectedRowKeys,
        setSelectedRow,
        setDescRows,
    } = usePurchaseEnquiryModel()
    const { getTreeNodeName } = useDictModel();
    const { supplierMap } = supplierMapModel();
    const { beShopDs, supplieAllList, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { getSelectedDictOne } = useDictModel();
    const typeForm: any = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("11-6-1") && resetAddCatch(mode);
            !findNav("11-6-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    useEffect(() => {
        let dataList = mode === 'edit' ? detailDataSource : detailAddList
        if (typeForm[mode].approveTypeCode == 'approval-type.001') {
            if (dataList.length > 0) {
                let newData = dataList.map(item => {
                    // 创建一个新的 details 数组
                    let updatedDetails: any = [];
                    // 遍历目标供应商列表
                    typeForm[mode]?.supplierList?.forEach((val: any) => {
                        // 查找是否已存在该供应商
                        let existingSupplier = item.details?.find((detail: any) => detail.supplierName === val.name);
                        if (existingSupplier) {
                            // 如果存在，直接添加到新的 details 中
                            updatedDetails.push(existingSupplier);
                        } else {
                            // 如果不存在，创建一个新的供应商对象并添加到 details 中
                            updatedDetails.push({
                                id: ``, // 生成一个随机 ID
                                supplierCode: val.code,
                                supplierName: val.name,
                                materialCode: item.materialCode,
                                materialName: item.materialName,
                                controlPrice: 0
                            });
                        }
                    });
                    // 更新 item 的 details
                    item.details = updatedDetails;
                    return item;
                });
                mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
            }
            const supplier = supplierMap.filter(e => typeForm[mode]?.supplierList.map((list: any) => list.code).indexOf(e.code) > -1);
            setSupplier(supplier);
        } else {
            setSupplier([]);
        }
    }, [typeForm[mode]?.supplierList])

    const save = () => {
        let goods = mode === "add" ? detailAddList : detailDataSource
        IFormRef.current?.validateFields().then(async res => {
            const { fileList = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            }
            else {
                val.md5 = ''
                val.fileName = ''
            }
            val.supplierInfo = typeForm[mode]?.supplierList?.map((item: any) => item.code).toString()
            val.endTime = val.endTime ? moment(val.endTime).format("YYYY-MM-DD HH:mm:ss") : ''
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    goBack();
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode === "edit") {
                let { id, enquiryCode } = detailEditForm
                const resData = await editDetail({ ...detailEditForm, ...val, id, enquiryCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(id as string, mode)
                }
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "11-6")
    }
    const onSubmit = async () => {
        if (!verifyGoods(mode)) return;
        globalPrompt("modal", {
            title: "发布询价",
            type: "warning",
            text: <div>
                <div style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#333',
                }}>
                    您正发布此条单据，是否确认？？
                </div>
                <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                    <div style={{
                        padding: '3px 0',
                        color: '#495057'
                    }}>
                        <span style={{ fontWeight: '500', color: '#2d3436' }}>报价截止时间：</span>
                        <span style={{ color: '#00BE87' }}>{momentFormat(typeForm[mode].endTime)}</span>
                    </div>

                    <div style={{
                        padding: '3px 0',
                        color: '#495057',
                    }}>
                        <span style={{ fontWeight: '500', color: '#2d3436' }}>询价类型：</span>
                        <span style={{ color: '#00BE87' }}>{getTreeNodeName(typeForm[mode].type)}</span>
                    </div>

                    <div style={{
                        padding: '3px 0',
                        color: '#495057',
                    }}>
                        <span style={{ fontWeight: '500', color: '#2d3436' }}>供应商信息：</span>
                        <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                            {typeForm[mode]?.supplierList?.map((supplier: any, index: any) => (
                                <div
                                    key={index}
                                    style={{ margin: '3px 0', color: '#00BE87' }}
                                >
                                    {index + 1}. {supplier.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            ,
            okText: "确定",
            onOk: async () => {
                let ret = await Submit()
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "询价单发布成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "询价单发布失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )

    }
    const onTrunPo = async (value: any, message: any) => {
        globalPrompt("modal", {
            title: "询价审核",
            type: "warning",
            text: `您正在审批此条单据'${message}'，是否确认？？`,
            okText: "确定",
            onOk: async () => {
                let ret = await Transfer(value)
                if (ret) {
                    resetEditCatch(mode);
                    goBack();
                    globalPrompt("message", { "text": "审核成功", "type": "success" });
                } else {
                    globalPrompt("message", { "text": "审核失败", "type": "error" })
                }
            },
            cancelText: "取消",
            onCancel: () => { }
        }
        )
    }
    const rightChildren = <>
        {(mode == 'add' || typeForm[mode].status == "purchase_enquiry.init") && <>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ONSUBMIT}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => {
                        if (!typeForm[mode].endTime) {
                            return message.error('请先选择截止时间')
                        }
                        onSubmit()
                    }, 900)}
                >发布</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        </>
        }
        {(mode == "edit" && typeForm[mode].status === "purchase_enquiry.end") && <>

            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ONTRUNPO}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { onTrunPo('purchase_enquiry.audited', '审批通过') }, 900)}
                >审批通过</Button>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    danger
                    disabled={topButsControl}
                    onClick={debounce(() => { onTrunPo('purchase_enquiry.reject', '审批驳回') }, 900)}
                >审批驳回</Button>
            </YhAuth>
        </>
        }
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>;

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const disabledDate = (current: Moment) => {
        return current && current < moment(typeForm[mode].endTime)
    }
    const typeChange = (value: string, option: ISelectOption) => {
        if (value == 'Inquiry-type.002' || !typeForm[mode].approveTypeCode) {
            onChange({ supplierList: [], typeName: option.label, type: option.value })
        } else {
            onChange({
                typeName: option.label,
                type: option.value,
                supplierList: supplieAllList.filter((list: any) => list.typeCode == returnList[typeForm[mode].approveTypeCode]).map((item: any) => { return { code: item.code, name: item.name, userCode: item.userCode, type: item.typeCode } })
            })
        }
    }
    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }
    //审批类型
    const approveTypeCodeChange = (value: string, option: ISelectOption) => {
        if (typeForm[mode].type == 'Inquiry-type.001') {
            onChange({ approveTypeCode: option.value, approveTypeName: option.label, supplierList: supplieAllList.filter((list: any) => list.typeCode == returnList[option.value]).map((item: any) => { return { code: item.code, name: item.name, userCode: item.userCode, type: item.typeCode } }) });
        } else {
            option && onChange({ approveTypeCode: option.value, approveTypeName: option.label, supplierList: [] });
        }
    }
    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "询价标题",
                fieldName: "title",
                rules: [{ required: true, message: "请输入询价标题" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "报价截止时间",
                format: "YYYY-MM-DD HH:mm:ss",
                showTime: { defaultValue: moment("00:00:00", "HH:mm:ss") },
                fieldName: "endTime",
                rules: [{ required: true, message: "请选择截止时间" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "审批类型",
                fieldName: "approveTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.APPROVAL_TYPE),
                showSearch: false,
                onSelectChange: approveTypeCodeChange,
                rules: [{ required: true, message: "请选择审批类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "approveTypeName",
                fieldName: "approveTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Select,
                showSearch: true,
                fieldLabel: "询价类型",
                fieldName: "type",
                onSelectChange: typeChange,
                options: getSelectedDictOne(DictCodeEnmu.INQUIRY_TYPE),
                rules: [{ required: true, message: "请选择审批类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发布人",
                fieldName: "sendUser",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发布时间",
                fieldName: "sendTime",
                disable: true,
                placeholder: "自动生成",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审批人",
                fieldName: "approver",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审批时间",
                fieldName: "approvalTimes",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编辑人",
                fieldName: "updateUser",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编辑时间",
                fieldName: "updateTimes",
                disable: true,
                placeholder: "自动生成",
                // colClassName:"iscm-ant-col-5"
            },
            // {
            //     type: FormItemTypeEnum.Radio,
            //     fieldLabel: "提醒方式",
            //     fieldName: "sendType",
            //     radioDs: [{ label: "短信通知", value: 'note' }],
            //     rules: [{ required: true, message: "请选择提醒方式" }],
            //     span: 8,
            // },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 16,
                hidden: mode == 'look' && !detailLookForm.md5 ? true : false,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {mode !== 'look' &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>}
                        </Upload>
                    </Form.Item>
                ),
            },
        ]
    };


    const onChange = (changedValues: { [key: string]: any }) => {
        let newChangedValues = changedValues;
        mode === "add" ? updateAddFormVal(newChangedValues) : updatEditFormVal(newChangedValues);
        setTopButsControl(true)
    }


    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode === DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }

    const supplierDelete = (record: any) => {
        let newData = typeForm[mode]?.supplierList?.filter((item: any) => item.code !== record)
        onChange({ supplierList: newData })
        setTopButsControl(true)
    }
    const action = <>
        {mode !== "look" &&
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                disabled={typeForm[mode].type == 'Inquiry-type.001' && (mode == 'add' || typeForm[mode].status == "purchase_enquiry.init")}
                onClick={() => {
                    if (!typeForm[mode].approveTypeCode) {
                        return message.error('请先选择审批类型')
                    }
                    setAddSupplierVisible(true)
                }}
            >追加供应商</Button>
        }
    </>;
    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        询价单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].code ?? "暂无"}</span>
                        单据状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: 'red' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
            <YhBox title="供应商信息" rightChildren={action} style={{ marginBottom: "10px" }}>
                {typeForm[mode]?.supplierList?.map((item: any) => (
                    <Tag
                        icon={<BankOutlined />}
                        key={item.code}
                        style={{ minWidth: '95px', height: '32px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                        color="geekblue"
                        closable={typeForm[mode].type == 'Inquiry-type.001' ? false : true}
                        onClose={() => supplierDelete(item.code)}
                    >
                        {item.name}
                    </Tag>
                ))}
            </YhBox>
        </>
    )
}